import colors from './colors';
import typography from './typography';

const theme = {
  colors,
  typography
};

export default theme;
